import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ColorLogo from "../assets/login/ColorLogo.png";
import logo1 from "../assets/header/HABD.png";
import logo2 from "../assets/login/DMW_Patiala.png";
import api from "../services/AxiosConnection.js";

const DownloadPDF = async (
  selectedSite,
  selectedSiteName,
  trainDetails,
  setIsLoading
) => {
  try {
    setIsLoading(true);
    if (!selectedSite || !trainDetails?.TrainId) {
      throw new Error("Missing selectedSite or TrainId");
    }

    const user = JSON.parse(localStorage.getItem("user"));
    const userName = user?.username || "Guest";
    const downloadDate = new Date();
    const formattedDateTime = `${downloadDate.toLocaleDateString()} ${downloadDate.toLocaleTimeString()}`;

    const response = await api.get(
      `/simple-view/GetTrainDataByTrainId?siteDb=${selectedSite}&trainId=${trainDetails.TrainId}`
    );
    const { trainTransactions, noOfTempSensors, data, alarms, warnings } = response.data || {};

    const doc = new jsPDF({ orientation: "landscape" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const logoWidth = 18;
    const logoHeight = 15;

    const addHeader = () => {
      doc.setTextColor(0, 0, 0);

      if (ColorLogo) {
        const logoX = 10;
        const logoY = 5;
        const logoW = 35;
        const logoH = logoHeight;

        doc.addImage(ColorLogo, "PNG", logoX, logoY, logoW, logoH);
        doc.link(logoX, logoY, logoW, logoH, {
          url: "https://noviusrailtech.com/",
        });
      }

      if (logo2) {
        doc.addImage(
          logo2,
          "PNG",
          pageWidth - logoWidth - 10,
          5,
          logoWidth,
          logoHeight
        );
      }

      const titleText =
        "NOVIUS HABD (Lite) - NOVIUS HOT AXLE BOX DETECTION SYSTEM (LITE MODEL)";
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");

      const textWidth = doc.getTextWidth(titleText);
      const centerX = pageWidth / 2;
      const offsetX = 20;
      const textX = centerX - textWidth / 2 + offsetX;

      if (logo1) {
        const logo1X = textX - logoWidth - 4;
        doc.addImage(logo1, "PNG", logo1X, 5, logoWidth, logoHeight);
      }

      doc.text(titleText, textX, 15);
      doc.setDrawColor(200, 200, 200);
      doc.line(10, 22, pageWidth - 10, 22);
    };

    const addFooter = () => {
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        const pageStr = `Page ${i} of ${pageCount}`;
        doc.text(
          pageStr,
          pageWidth - 14 - doc.getTextWidth(pageStr),
          pageHeight - 10
        );

        doc.setTextColor(80);
        doc.setFont("helvetica", "italic");
        const footerText = `Downloaded by: ${userName} | Download Time: ${formattedDateTime}`;
        doc.text(footerText, 14, pageHeight - 10);
      }
    };

    addHeader();

    let lastTableY = 40;

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(`Site: ${selectedSiteName || "N/A"}`, 14, lastTableY);
    lastTableY += 15;

    if (trainTransactions?.length > 0) {
      const train = trainTransactions[0];
      const formattedTrainId = formatPdfDate(train.TrainId);
      const trainName =
        train.TrainName && train.TrainName !== "Train Name"
          ? train.TrainName
          : "N/A";
      const trainNumber =
        train.TrainNumber && train.TrainNumber !== "Train Number"
          ? train.TrainNumber
          : "N/A";

      doc.text("Train Details", 14, lastTableY);
      lastTableY += 10;

      autoTable(doc, {
        startY: lastTableY,
        margin: { left: 10, right: 10 },
        body: [
          [
            {
              content: "Train Date & Time",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            { content: formattedTrainId },
            {
              content: "Train Name",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            { content: trainName },
            {
              content: "Train Number",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            { content: trainNumber },
            {
              content: "Direction",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            { content: train.Direction || "N/A" },
          ],
          [
            {
              content: "Average Speed",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            {
              content: train.AvgSpeed ? Number(train.AvgSpeed).toFixed(2) : "N/A",
            },
            {
              content: "Number of Coaches",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            { content: train.NoBogi || "N/A" },
            {
              content: "Number of Locos",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            { content: train.NoLoco || "N/A" },
            {
              content: "Atmospheric Temp (°C)",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            {
              content: train.AtmosphereTemp
                ? Number(train.AtmosphereTemp).toFixed(2)
                : "N/A",
            },
          ],
          [
            {
              content: "Number of Axles",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            { content: train.TotalNoOfAxles || "N/A" },
            {
              content: "Max Axle Temp Diff (°C)",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            {
              content: train.Max_Avg_Temp_Diff
                ? Number(train.Max_Avg_Temp_Diff).toFixed(2)
                : "N/A",
            },
            {
              content: "Max Avg Axle Temp (°C)",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            {
              content: train.Max_Avg_Axle_Temp
                ? Number(train.Max_Avg_Axle_Temp).toFixed(2)
                : "N/A",
            },
            {
              content: "Coach Type",
              styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
            },
            { content: train.Description || "N/A" },
          ],
        ],
        theme: "grid",
        styles: {
          fontSize: 10,
          cellPadding: 3,
          textColor: [0, 0, 0],
          fillColor: [255, 255, 255],
          halign: "center",
          valign: "middle",
        },
        columnStyles: {
          0: { cellWidth: 34.625 },
          1: { cellWidth: 34.625 },
          2: { cellWidth: 34.625 },
          3: { cellWidth: 34.625 },
          4: { cellWidth: 34.625 },
          5: { cellWidth: 34.625 },
          6: { cellWidth: 34.625 },
          7: { cellWidth: 34.625 },
        },
        didDrawPage: addHeader,
        didDrawTable: (data) => {
          // console.log("Train Details finalY:", data.table.finalY);
        },
      });
    } else {
      doc.text("No train transaction data available", 14, lastTableY);
    }

    doc.addPage();
    addHeader();
    lastTableY = 40;

    if (data?.length > 0) {
      // console.log("Rendering Temperature Details, lastTableY:", lastTableY);
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("Temperature Details", 14, lastTableY);
      lastTableY += 10;

      const columns = [
        { content: "Axle No", styles: { halign: "center" } },
        { content: "Axle Speed", styles: { halign: "center" } },
        { content: "Coach Position", styles: { halign: "center" } },
        { content: "Coach Number", styles: { halign: "center" } },
        { content: "LH Axle (°C)", styles: { halign: "center" } },
        { content: "RH Axle (°C)", styles: { halign: "center" } },
        { content: "Temp Difference (°C)", styles: { halign: "center" } },
      ];

      if (noOfTempSensors >= 4) {
        columns.push(
          { content: "LH Wheel (°C)", styles: { halign: "center" } },
          { content: "RH Wheel (°C)", styles: { halign: "center" } },
          { content: "Temp Difference (°C)", styles: { halign: "center" } }
        );
      }

      if (noOfTempSensors >= 6) {
        columns.push(
          { content: "LH Brake Disc (°C)", styles: { halign: "center" } },
          { content: "RH Brake Disc (°C)", styles: { halign: "center" } },
          { content: "Temp Difference (°C)", styles: { halign: "center" } }
        );
      }

      if (noOfTempSensors >= 2) {
        columns.push(
          { content: "LH Side Axle Avg (°C)", styles: { halign: "center" } },
          { content: "RH Side Axle Avg (°C)", styles: { halign: "center" } },
          { content: "Whole Coach Axle Avg (°C)", styles: { halign: "center" } }
        );
      }

      if (noOfTempSensors >= 4) {
        columns.push(
          { content: "LH Side Wheel Avg (°C)", styles: { halign: "center" } },
          { content: "RH Side Wheel Avg (°C)", styles: { halign: "center" } },
          { content: "Whole Coach Wheel Avg (°C)", styles: { halign: "center" } }
        );
      }

      if (noOfTempSensors >= 6) {
        columns.push(
          { content: "LH Side Brake Avg (°C)", styles: { halign: "center" } },
          { content: "RH Side Brake Avg (°C)", styles: { halign: "center" } },
          { content: "Whole Coach Brake Avg (°C)", styles: { halign: "center" } }
        );
      }

      const body = [];
      const rowSpanMap = new Map();
      let rowIndex = 0;

      // Flatten and sort data by AxleNo
      const sortedLogs = [];
      data.forEach((coach) => {
        const logs = coach.TemperatureLogs || coach.temperatureLogs || [];
        if (logs.length) {
          // Get coach position from various possible fields
          let coachPosition = coach.CoachPosition || coach.coachPosition || coach.Position || "N/A";
          
          // Handle WAG12 coaches with multiple axles
          if (coachPosition.toUpperCase() === "WAG12" && logs.length > 4) {
            const wag12Count = Math.ceil(logs.length / 8); // Each WAG12 has 8 axles (2 groups of 4)
            logs.forEach((log, index) => {
              const wag12Number = Math.floor(index / 8) + 1;
              const subGroup = Math.floor((index % 8) / 4) + 1; // 1.1 or 1.2
              sortedLogs.push({
                log,
                coach,
                position: `WAG12 ${wag12Number}.${subGroup}`,
                isLoco: false,
                tempCalcs: coach.TempCalculations && coach.TempCalculations.length > 0
                  ? coach.TempCalculations[0]
                  : null,
              });
            });
          } else {
            logs.forEach((log) => {
              sortedLogs.push({
                log,
                coach,
                position: coachPosition,
                isLoco: coachPosition.toUpperCase().startsWith("LOCO"),
                tempCalcs: coach.TempCalculations && coach.TempCalculations.length > 0
                  ? coach.TempCalculations[0]
                  : null,
              });
            });
          }
        }
      });

      // Sort by AxleNo (assuming AxleNo is a number or can be parsed as one)
      sortedLogs.sort((a, b) => {
        const axleA = parseInt(a.log.AxleNo) || 0;
        const axleB = parseInt(b.log.AxleNo) || 0;
        return axleA - axleB;
      });

      // Group logs by position for row spanning
      const groupedLogs = {};
      sortedLogs.forEach((logData) => {
        const key = `${logData.position}_${logData.coach.CoachNo || logData.coach.coachNo || logData.coach.coach_number || logData.coach.CoachNumber || "N/A"}`;
        if (!groupedLogs[key]) {
          groupedLogs[key] = [];
        }
        groupedLogs[key].push(logData);
      });

      // Process each group
      Object.values(groupedLogs).forEach((group) => {
        const mergeSpan = group[0].isLoco ? 6 : 4;
        const isWAG12 = group[0].position.startsWith("WAG12");
        
        group.forEach(({ log, coach, position, tempCalcs }, i) => {
          const row = [
            { content: log.AxleNo || "N/A" },
            { content: log.AxelSpeed ? Number(log.AxelSpeed).toFixed(2) : "N/A" },
            { content: position },
            {
              content:
                log.CoachNo ||
                log.coachNo ||
                log.coach_number ||
                log.CoachNumber ||
                "N/A",
            },
            { content: log.Ts1 ? Number(log.Ts1).toFixed(2) : "N/A" },
            { content: log.Ts2 ? Number(log.Ts2).toFixed(2) : "N/A" },
          ];

          if (noOfTempSensors >= 2) {
            const tempDiff =
              log.Ts1 && log.Ts2
                ? Number(Math.abs(log.Ts1 - log.Ts2)).toFixed(2)
                : "N/A";
            row.push({ content: tempDiff });
          }

          if (noOfTempSensors >= 4) {
            row.push(
              { content: log.Ts3 ? Number(log.Ts3).toFixed(2) : "N/A" },
              { content: log.Ts4 ? Number(log.Ts4).toFixed(2) : "N/A" }
            );
            const tempDiff =
              log.Ts3 && log.Ts4
                ? Number(Math.abs(log.Ts3 - log.Ts4)).toFixed(2)
                : "N/A";
            row.push({ content: tempDiff });
          }

          if (noOfTempSensors >= 6) {
            row.push(
              { content: log.Ts5 ? Number(log.Ts5).toFixed(2) : "N/A" },
              { content: log.Ts6 ? Number(log.Ts6).toFixed(2) : "N/A" }
            );
            const tempDiff =
              log.Ts5 && log.Ts6
                ? Number(Math.abs(log.Ts5 - log.Ts6)).toFixed(2)
                : "N/A";
            row.push({ content: tempDiff });
          }

          // Only add averages for the first row of each group
          if (i === 0) {
            if (noOfTempSensors >= 2) {
              row.push(
                {
                  content: tempCalcs?.LHSideAxleAvg
                    ? Number(tempCalcs.LHSideAxleAvg).toFixed(2)
                    : "N/A",
                },
                {
                  content: tempCalcs?.RHSideAxleAvg
                    ? Number(tempCalcs.RHSideAxleAvg).toFixed(2)
                    : "N/A",
                },
                {
                  content: tempCalcs?.WholeCoachAxleAvg
                    ? Number(tempCalcs.WholeCoachAxleAvg).toFixed(2)
                    : "N/A",
                }
              );
            }

            if (noOfTempSensors >= 4) {
              row.push(
                {
                  content: tempCalcs?.LHSideWheelAvg
                    ? Number(tempCalcs.LHSideWheelAvg).toFixed(2)
                    : "N/A",
                },
                {
                  content: tempCalcs?.RHSideWheelAvg
                    ? Number(tempCalcs.RHSideWheelAvg).toFixed(2)
                    : "N/A",
                },
                {
                  content: tempCalcs?.WholeCoachWheelAvg
                    ? Number(tempCalcs.WholeCoachWheelAvg).toFixed(2)
                    : "N/A",
                }
              );
            }

            if (noOfTempSensors >= 6) {
              row.push(
                {
                  content: tempCalcs?.LHSideBrakeAvg
                    ? Number(tempCalcs.LHSideBrakeAvg).toFixed(2)
                    : "N/A",
                },
                {
                  content: tempCalcs?.RHSideBrakeAvg
                    ? Number(tempCalcs.RHSideBrakeAvg).toFixed(2)
                    : "N/A",
                },
                {
                  content: tempCalcs?.WholeCoachBrakeAvg
                    ? Number(tempCalcs.WholeCoachBrakeAvg).toFixed(2)
                    : "N/A",
                }
              );
            }
          }

          body.push(row);
          
          // Set row span for position and coach number columns
          if (i === 0) {
            rowSpanMap.set(rowIndex, isWAG12 ? group.length : mergeSpan);
          }
          rowIndex++;
        });
      });

      if (body.length > 0) {
        autoTable(doc, {
          startY: lastTableY,
          margin: { top: 40, left: 10, right: 10 },
          head: [columns],
          body: body,
          theme: "grid",
          styles: {
            fontSize: 10,
            cellPadding: 3,
            textColor: [0, 0, 0],
            fillColor: [255, 255, 255],
            halign: "center",
            valign: "middle",
          },
          headStyles: {
            fillColor: [220, 220, 220],
            textColor: [0, 0, 0],
            fontStyle: "bold",
          },
          didParseCell: (data) => {
            if (data.section === "body") {
              const span = rowSpanMap.get(data.row.index);
              const avgStartIndex =
                noOfTempSensors >= 6
                  ? 13 // After Brake Temp Difference
                  : noOfTempSensors >= 4
                  ? 10 // After Wheel Temp Difference
                  : 7; // After Axle Temp Difference

              if (data.column.index === 2 || data.column.index === 3) {
                if (span) {
                  data.cell.rowSpan = span;
                  data.cell.styles.valign = "middle";
                  data.cell.styles.halign = "center";
                } else {
                  data.cell.text = [""];
                }
              }

              if (data.column.index >= avgStartIndex) {
                if (span) {
                  data.cell.rowSpan = span;
                  data.cell.styles.valign = "middle";
                  data.cell.styles.halign = "center";
                  data.cell.styles.fillColor = [240, 248, 255];
                } else {
                  data.cell.text = [""];
                }
              }
            }
          },
          didDrawPage: addHeader,
          didDrawTable: (data) => {
            // console.log("Temperature Details finalY:", data.table.finalY);
          },
        });
      } else {
        doc.text("No valid temperature log data available", 14, lastTableY);
      }

      if (alarms?.length > 0) {
        doc.addPage();
        addHeader();
        lastTableY = 40;

        // console.log("Rendering Alarm Details, alarms:", alarms, "lastTableY:", lastTableY);
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text("Alarm Details", 14, lastTableY);
        lastTableY += 10;

        const alarmColumns = [
          { content: "Axle No", styles: { halign: "center" } },
          { content: "Coach Position", styles: { halign: "center" } },
          { content: "Coach Number", styles: { halign: "center" } },
          { content: "Side", styles: { halign: "center" } },
          { content: "Temperature (°C)", styles: { halign: "center" } },
        ];

        const alarmBody = alarms.map((alarm) => [
          { content: alarm.AxelNo || alarm.AxleNo || "N/A" },
          { content: alarm.CoachPosition || "N/A" },
          { content: alarm.CoachNo || "N/A" },
          { content: alarm.Side || "N/A" },
          {
            content: alarm.Temperature
              ? Number(alarm.Temperature).toFixed(2)
              : "N/A",
          },
        ]);

        autoTable(doc, {
          startY: lastTableY,
          margin: { top: 40, left: 10, right: 10 },
          head: [alarmColumns],
          body: alarmBody,
          theme: "grid",
          styles: {
            fontSize: 10,
            cellPadding: 3,
            textColor: [0, 0, 0],
            fillColor: [255, 255, 255],
            halign: "center",
            valign: "middle",
          },
          headStyles: {
            fillColor: [220, 220, 220],
            textColor: [0, 0, 0],
            fontStyle: "bold",
          },
          didDrawPage: addHeader,
          didDrawTable: (data) => {
            // console.log("Alarm Details finalY:", data.table.finalY);
          },
        });
      }

      if (warnings?.length > 0) {
        doc.addPage();
        addHeader();
        lastTableY = 40;

        // console.log("Rendering Warning Details, warnings:", warnings, "lastTableY:", lastTableY);
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text("Warning Details", 14, lastTableY);
        lastTableY += 10;

        const warningColumns = [
          { content: "Axle No", styles: { halign: "center" } },
          { content: "Coach Position", styles: { halign: "center" } },
          { content: "Coach Number", styles: { halign: "center" } },
          { content: "Side", styles: { halign: "center" } },
          { content: "Temperature (°C)", styles: { halign: "center" } },
        ];

        const warningBody = warnings.map((warning) => [
          { content: warning.AxelNo || warning.AxleNo || "N/A" },
          { content: warning.CoachPosition || "N/A" },
          { content: warning.CoachNo || "N/A" },
          { content: warning.Side || "N/A" },
          {
            content: warning.Temperature
              ? Number(warning.Temperature).toFixed(2)
              : "N/A",
          },
        ]);

        autoTable(doc, {
          startY: lastTableY,
          margin: { top: 40, left: 10, right: 10 },
          head: [warningColumns],
          body: warningBody,
          theme: "grid",
          styles: {
            fontSize: 10,
            cellPadding: 3,
            textColor: [0, 0, 0],
            fillColor: [255, 255, 255],
            halign: "center",
            valign: "middle",
          },
          headStyles: {
            fillColor: [220, 220, 220],
            textColor: [0, 0, 0],
            fontStyle: "bold",
          },
          didDrawPage: addHeader,
          didDrawTable: (data) => {
            // console.log("Warning Details finalY:", data.table.finalY);
          },
        });
      }
    } else {
      doc.text("No valid temperature log data available", 14, lastTableY);
    }

    addFooter();
    // Generate PDF file name: SiteName - DD/MM/YYYY - HH:MM:SS
    const trainIdParts = trainDetails.TrainId ? trainDetails.TrainId.split("_") : [];
    const formattedDate = trainIdParts.length === 7 
      ? `${trainIdParts[2]}/${trainIdParts[1]}/${trainIdParts[0]}`
      : "N/A";
    const formattedTime = trainIdParts.length === 7 
      ? `${parseInt(trainIdParts[3], 10)}:${trainIdParts[4]}:${trainIdParts[5]}`
      : "N/A";
    const pdfFileName = `${selectedSiteName || "UnknownSite"} - ${formattedDate} - ${formattedTime}.pdf`;
    doc.save(pdfFileName);
  } catch (error) {
    console.error("Error generating PDF:", error);
    alert(`Failed to generate PDF: ${error.message}`);
  } finally {
    setIsLoading(false);
  }
};

const formatPdfDate = (trainId) => {
  if (!trainId) return "N/A";
  const parts = trainId.split("T");
  if (parts.length !== 2) {
    const [year, month, day, hour, minute] = trainId.split("_").slice(0, 5);
    return `${day}/${month}/${year} ${hour}:${minute}`;
  }
  const [datePart, timePart] = parts;
  const [year, month, day] = datePart.split("_");
  const [hour, minute] = timePart.split("_").slice(0, 2);
  return `${day}/${month}/${year} ${hour}:${minute}`;
};

export default DownloadPDF;